<template>
  <button
    :id="buttonId"
    :class="buttonClass"
    :type="buttonType"
    @click.prevent="buttonListener"
    :disabled="isLoading || isDisabled"
  >
    <Loading
      v-if="isLoading"
      shape="circle"
      :stroke-width="2"
      :size="12"
      rotate
      :indeterminate="true"
    />
    <span v-else>{{ buttonText }}</span>
  </button>
</template>

<script>
import { mapGetters } from "vuex";
import Loading from "./Loading";

export default {
  name: "SpinnerButton",
  components: {
    Loading,
  },
  props: {
    buttonId: {
      type: String,
      default: null,
      required: false,
    },
    buttonClass: {
      type: String,
      required: true,
    },
    buttonType: {
      type: String,
      required: true,
    },
    buttonListener: {
      type: Function,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    isDisabled: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
};
</script>
